import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import VoiceAssistant from "./components/VoiceAssistant";
import VisitorCounter from "./components/VisitorCounter";
import WhatsAppButton from "./components/WhatsAppButton";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Memories from "./pages/Memories";
import Booking from "./pages/Booking";
import Apps from "./pages/Apps";
import Admin from "./pages/Admin";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#faf6ee]">
      <Header />
      <main>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Education />
        <Contact />
      </main>
      <Footer />
      <VoiceAssistant />
      <VisitorCounter />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/memories" element={<Memories />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
